const DEFAULT_API_URL = "http://localhost:3003/api/v1/parent-app";

/**
 * Runtime config loaded from /env.js (window.__ENV__).
 * Falls back to REACT_APP_API_URL for local dev without env.js.
 */
export function getApiBaseUrl() {
  if (typeof window !== "undefined" && window.__ENV__?.API_URL) {
    return window.__ENV__.API_URL;
  }

  return process.env.REACT_APP_API_URL || DEFAULT_API_URL;
}

export function getAuthApiUrl() {
  return `${getApiBaseUrl()}/auth`;
}

export function getStudentsApiUrl() {
  return `${getApiBaseUrl()}/students`;
}
